/* src/app/builder-screen-beta/event-scripting/simple-mode/behavior-preview.component.scss */
.behavior-preview {
  padding: 16px 0;
}
.preview-details {
  margin-top: 16px;
}
/*# sourceMappingURL=behavior-preview.component.css.map */
